import '@xuwo/env/constant';
import '../types/types.d.ts';

import { setupGlobal } from '@xuwo/env/global';

setupGlobal();
